import React from 'react'
import './TransactionHistory.css'

function TransactionHistory() {
    return (
             <div className='transaction'>
            <h5 className="transaction-title">Transaction History</h5>
            <p className="transaction-p">These are all your previous transactions</p>
        </div>
    )
}

export default TransactionHistory

